<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>{{ $t('vouchers.edit') }}</h4>
          </div>
          <div class="card-body">
            <VouchersForm 
              @submit-requested="formSubmitted" 
              :baseVoucher="voucher" 
              :baseVoucherName="voucherName"
              :loading="loading" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VouchersForm from './VouchersForm.vue';
import router from '@/router';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    VouchersForm
  },
  data() {
    return {
      loading: false,
      voucherName: null
    }
  },
  computed: {
    ...mapState('vouchers', ['getVoucherByIdOutput']),
    voucher() {
      return this.getVoucherByIdOutput?.data || null;
    }
  },
  async mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loading = true;
      try {
        await this.getById(id);
        this.voucherName = this.$route.params.code || this.voucher?.code;
      } catch (error) {
        console.error('Error loading voucher:', error);
        router.push({ name: 'VouchersList' });
      } finally {
        this.loading = false;
      }
    } else {
      router.push({ name: 'VouchersList' });
    }
  },
  methods: {
    ...mapActions('vouchers', ['getById', 'update']),
    async formSubmitted(voucherData) {
      try {
        this.loading = true;
        await this.update({ ...voucherData, id: this.voucher.id });
        router.push({ name: 'VouchersList' });
      } catch (error) {
        console.error('Error updating voucher:', error);
        this.loading = false;
      }
    }
  }
}
</script>

